import { AddCircleOutlineIc } from '@dsch/dd-icons';

import { Button } from '../../../../../components/Toolkit/Button/Button';
import { ButtonProps } from '../../../../../components/Toolkit/Button/SharedButton';
import { shouldShowTrims } from '../MakeModel.constants';

type AddButtonProps = ButtonProps & {
  sectionName?: string;
};

const AddButton = (props: AddButtonProps) => {
  const { sectionName, ...buttonProps } = props;
  const showTrims = shouldShowTrims(sectionName);

  return (
    <Button
      ofType="SECONDARY"
      {...buttonProps}
      data-testid="add-another-vehcile"
    >
      <AddCircleOutlineIc />
      &nbsp; {showTrims ? 'Add another vehicle' : 'Add another'}
    </Button>
  );
};

export { AddButton };
